export enum FilterGroupOperator {
  And = 'and',
  Or = 'or',
}
